export const contingentDoneCircleIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 15 15"><path d="M3.363 8.09l2.364 2.364 4.727-5.909" stroke="#1ABC9C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M7.5 14a6.5 6.5 0 100-13 6.5 6.5 0 000 13z" stroke="#1ABC9C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'done-circle',
};
